// animated-number.tsx

import { useEffect } from 'react';

import { motion, useSpring, useTransform } from 'motion/react';

const springOptions = {
  mass: 0.5, // lighter "object"
  stiffness: 200, // stronger pull → faster
  damping: 20 // keeps it from oscillating too much
};

export const AnimatedNumber = ({ value }: { value: number }) => {
  const spring = useSpring(value, springOptions);
  const display = useTransform(spring, current =>
    Math.round(current).toLocaleString()
  );

  useEffect(() => {
    spring.set(value);
  }, [spring, value]);

  return <motion.span>{display}</motion.span>;
};
